<div #container class="graph-div">
    <div [hidden]="loading">
        <endoo-canvas #graph></endoo-canvas>
    </div>

    <div *ngIf="loading" class="loading-div">
        <div class="loader"></div>
    </div>
</div>
